export default __webpack_public_path__ + "static/media/banner-3.42480ca7.jpg";